export const CaseStatusBehaviourTypes: Record<string, number> = {
  Open: 1,
  "On Hold": 2,
  Closed: 3,
};

export enum MeetingAttendeeTypes {
  Development = 1,
  Client = 2,
  Purchase = 3,
  Other = 4,
}

export enum UserTaskStatusTypes {
  Open = 1,
  Closed = 2,
  InProgress = 3,
  OnHold = 4,
  Cancelled = 5,
}

export enum UserTaskTypes {
  JobInstruction = 1,
  EstimateRequest = 2,
  ProposedWorkCreation = 3,
  AdHoc = 4,
  CaseTask = 5,
}

export enum SystemCaseStatusTypes {
  OPEN = 1,
  WITHCLIENT = 2,
  CLOSED = 3,
  INPROGRESS = 4,
  ONHOLD = 5,
}

export enum CalendarEventTypes {
  UserTask = 1,
  Meeting = 2,
  Event = 3,
}

export enum PaymentProviders {
  Blink = 1,
  GoCardless = 2,
}
